import React, { useCallback, useState } from "react";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import ExportLoadingModal from "Components/Common/ExportLoadingModal";
import { exportContractsToCSV } from "common/services/contracts.service";
import Permission from "Components/Common/Permission";
import { toast } from "react-toastify";
import ContractsImportModal from "./ContractsImportModal";

const Import = ({
  apiParams,
  onImported,
}: {
  apiParams?: any;
  onImported?: () => void;
}) => {
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);

  const [exporting, setExporting] = useState(false);
  const getCsvExport = useCallback(async () => {
    setExporting(true);

    await exportContractsToCSV({
      filters: apiParams.filters,
      sort: apiParams.sort,
    })
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Contracts_Export.csv");
        link.click();
        link.remove();
      })
      .catch((error: any) => {
        toast.error("An error occurred while exporting contracts");
      });

    setExporting(false);
  }, [apiParams]);
  return (
    <>
      <UncontrolledDropdown>
        <DropdownToggle
          tag="button"
          className="btn btn-light"
          id="dropdownMenuButton"
        >
          <i className="ri ri-more-fill"></i>
        </DropdownToggle>
        <DropdownMenu>
          <Permission resource="contract" action="import">
            <DropdownItem
              onClick={() => {
                setIsImportModalOpen(true);
              }}
            >
              <i className="ri ri-upload-2-line me-1"></i>
              Import
            </DropdownItem>
          </Permission>
          <Permission resource="contract" action="exportToCsv">
            <DropdownItem
              onClick={() => {
                getCsvExport();
              }}
            >
              <i className="ri ri-download-2-line me-1"></i>
              Export
            </DropdownItem>
          </Permission>
        </DropdownMenu>
      </UncontrolledDropdown>

      <ContractsImportModal
        toggle={() => setIsImportModalOpen(!isImportModalOpen)}
        isOpen={isImportModalOpen}
        onImported={onImported}
      />
      <ExportLoadingModal show={exporting} onCloseClick={() => {}} />
    </>
  );
};

export default Import;
